import { useState, useEffect, useContext, useRef } from "react";
import ViewSelector from './../../components/viewSelector/viewSelector'
import DateSelector from './../../components/dateSelector/dateSelector'
// import FullScreen from './../../layout/fullScreen/fullScreen'
import LightSelector from '../../components/lightSelector/lightSelector'
import Slider from './../../components/slider/slider'
import { ReactComponent as Eye } from './../../components/svg/files/picto-eye.svg';
import { navigationContext } from '../../context';
import useMobile from '../../globalHooks/useMobile';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Credits from "../../layout/credits/credits";
import FullScreen from "../../layout/fullScreen/fullScreen";

const Home = () => {
  const { helio, helioDatas } = useContext(navigationContext);
  const [filteredViewData, setFilteredViewData] = useState([]);
  const [displayViewName, setDisplayViewName] = useState(null);
  const [displayDateName, setDisplayDateName] = useState(null);
  const [showViewButtons, setShowViewButtons] = useState(false);
  const [showDateButtons, setShowDateButtons] = useState(false);
  const [selectedView, setSelectedView] = useState(null);
  const [selectedDate, setSelectedDate] = useState("SUMMER");
  const [selectedImagePath, setSelectedImagePath] = useState(null);
  const [imageNumber, setImageNumber] = useState(0);
  const [lastFrameNumber, setlastFrameNumber] = useState(null);
  const [startTotalMinutes, setStartTotalMinutes] = useState(null);
  const [timeStep, setTimeStep] = useState(null);
  const [planMasseImagePath, setPlanMasseImagePath] = useState(null);
  const [currentHour, setCurrentHour] = useState("");
  const [dragging, setDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(null);
  const [dragStartImageNumber, setDragStartImageNumber] = useState(null);
  const [planMasseOverlayPosition, setPlanMasseOverlayPosition] = useState({ hotspotX: 90, hotspotY: 90, orientation: 0 });
  const { hotspotX, hotspotY, orientation } = planMasseOverlayPosition;
  const [sunrise, setSunRise] = useState(null);
  const [sunset, setSunSet] = useState(null);
  const [date, setDate] = useState(null);
  const [showInstruction, setShowInstruction] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isNormalImage, setIsNormalImage] = useState(true);
  const [previousFirstFrameNumber, setPreviousFirstFrameNumber] = useState(380);
  const [previousImageNumber, setPreviousImageNumber] = useState(0);
  const [lightAnalysis, setLightAnalysis] = useState(null);
  const isMobile = useMobile();
  const pdfRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
        e.preventDefault();
      }
    };

    const pdf = pdfRef.current;

    if (pdf) {
      pdf.addEventListener('wheel', handleWheel);
      pdf.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (pdf) {
        pdf.removeEventListener('wheel', handleWheel);
        pdf.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, [pdfRef]);  const handleContextMenu = (event) => {
    event.preventDefault();
  };  // Capture d'écran en image PNG
  const downloadImage = () => {
    const input = pdfRef.current;
    
    // Masquer le plan masse avant la capture
    const planMasse = document.querySelector('.planMasseContainer');
    if (planMasse) {
      planMasse.style.display = 'none';
    }

    // Attendre un peu pour que les changements CSS soient appliqués
    setTimeout(() => {
      html2canvas(input, {
        useCORS: true,
        allowTaint: true,
        logging: false,
        scale: 1,
        backgroundColor: '#000000',
      }).then((canvas) => {
        // Convertir le canvas en image
        const imgData = canvas.toDataURL("image/png");

        // Créer un nom de fichier avec date lisible (YYYYMMDD_HHMMSS)
        const now = new Date();
        const dateStr = now.toISOString().slice(0, 19).replace(/[-:T]/g, '').slice(0, 8);
        const timeStr = now.toTimeString().slice(0, 8).replace(/:/g, '');
        const filename = `${helioDatas.generals[0].project}_${selectedView}_${selectedDate}_${dateStr}_${timeStr}.png`;

        // Créer un lien de téléchargement
        const link = document.createElement("a");
        link.href = imgData;
        link.download = filename;
        link.click();

        // Restaurer l'affichage du plan masse
        if (planMasse) {
          planMasse.style.display = 'flex';
        }
      }).catch((error) => {
        console.error('Erreur lors de la capture:', error);
        // Restaurer l'affichage du plan masse même en cas d'erreur
        if (planMasse) {
          planMasse.style.display = 'flex';
        }
      });
    }, 150);
  };

  const handleBoxClick = () => {
    setShowViewButtons(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        document.getElementById('viewSelector') &&
        !document.getElementById('viewSelector').contains(event.target) &&
        document.getElementById('dateSelector') &&
        !document.getElementById('dateSelector').contains(event.target)
      ) {
        setShowViewButtons(false);
        setShowDateButtons(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowViewButtons, setShowDateButtons]);

  const handleImageChange = (isNormalImage) => {
    if (!isNormalImage) {
      setSelectedImagePath((prevPath) => {
        const updatedPath = prevPath.replace(/(\.\d{4}\.jpg)$/, '.LGT_ANALYSIS$1');
        return updatedPath;
      });
    }
    // else {
    // //   setSelectedImagePath((prevPath) => {
    // //     const updatedPath = prevPath.replace(/\.LGT_ANALYSIS(\.\d{4}\.jpg)$/, '$1');
    // //     return updatedPath;
    // //   });
    // // }
    setIsNormalImage(isNormalImage);
  };

  useEffect(() => {
    if (helioDatas && helioDatas.generals && helioDatas.generals[0] && helioDatas.generals[0].lightAnalysis !== undefined) {
      setLightAnalysis(helioDatas.generals[0].lightAnalysis);
    }
  }, [helioDatas]);


  useEffect(() => {
    if (selectedView && selectedDate && helioDatas && helioDatas.cameras) {
      const selectedViewObject = helioDatas.cameras.find((view) => view.id === selectedView);
      if (selectedViewObject) {
        const imageName = `${selectedViewObject.id.toUpperCase()}.0000.jpg`;
        let imagePath = `/helio/${helio}/${selectedDate}/${selectedViewObject.id}/jpg-1440/${imageName}`;
        setSelectedImagePath(imagePath);
        handleImageChange(isNormalImage);
      }
    }
  }, [selectedView, selectedDate, helioDatas, isNormalImage]);

  const handleButtonClick = (type) => {
    if (type === 'view') {
      setShowViewButtons(!showViewButtons);
      setShowDateButtons(false);
    } else if (type === 'date') {
      setShowDateButtons(!showDateButtons);
      setShowViewButtons(false);
    }
  };

  const handleSelect = (item, type, name) => {
    if (type === 'view') {
      handleViewChange(item.id);
      setSelectedView(item.id);
      setSelectedDate(selectedDate);
      const selectedViewObject = helioDatas.cameras.find((view) => view.id === item.id);
      setFilteredViewData([selectedViewObject]);
      setDisplayViewName(item.displayName);
      setShowViewButtons(false);
    } else if (type === 'date') {
      setPreviousFirstFrameNumber(startTotalMinutes);
      setPreviousImageNumber(imageNumber);
      setDisplayDateName(name)
      handleDateChange(item);
      setSelectedDate(item);
      setShowDateButtons(false);
    }
  };

  const handleViewChange = (value) => {
    setSelectedView(value);

  }

  const handleDateChange = (value) => {
    setSelectedDate(value);

  }

  useEffect(() => {
    if (helioDatas) {
      const selectedViewData = helioDatas.cameras.find((view) => view.id === selectedView);
      const seasonData = selectedViewData && selectedViewData.seasons[selectedDate];

      if (seasonData) {
        // Mise à jour du nombre d'images max et de l'imageNumber pour qu'il ne dépasse pas le max
        setlastFrameNumber(seasonData.maxNumberFrame);
        if (imageNumber > seasonData.maxNumberFrame) {
          setImageNumber(seasonData.maxNumberFrame);
        }

        // Mise à jour du chemin du plan de masse
        const planMasseImageName = `${'HELIO_CAM_TOP'.toUpperCase()}.0000.jpg`;
        const planMasseImagePath = `/helio/${helio}/${selectedDate}/HELIO_CAM_TOP/jpg-1440/${planMasseImageName}`;
        setPlanMasseImagePath(planMasseImagePath);

        // ------ Gestion du système d'heure ------ //
        // Heure de la première image en format hh:mm
        // Deux points retirés hh mm
        // Heure de la première image convertie en chiffre(s) hh
        // Minutes de la première image convertie en chiffre(s) mm
        // Minutes totales de la première image mm
        // Pas de temps en minutes
        // Minutes totales de l'image actuelle
        // Heure de l'image actuelle en chiffre(s) hh
        // Minutes de l'image actuelle en chiffre(s) mm
        // Heure de l'image actuelle en format hh:mm

        const firstFrameTime = seasonData.firstFrameTime;
        const [hoursStr, minutesStr] = firstFrameTime.split(":");
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        setStartTotalMinutes(hours * 60 + minutes);
        setTimeStep(selectedViewData.timestep_minutes);
        const totalMinutes = startTotalMinutes + imageNumber * timeStep;
        const updatedHours = Math.floor(totalMinutes / 60);
        const updatedMinutes = totalMinutes % 60;
        const hourString = `${updatedHours.toString().padStart(2, '0')}:${updatedMinutes.toString().padStart(2, '0')}`;
        setCurrentHour(hourString);
        // ------ Fin gestion du système d'heure ------ //

        // Gestion de l'oeil sur le plan masse
        const hotspotX = seasonData.hotspotX ? seasonData.hotspotX : null;
        const hotspotY = seasonData.hotspotY ? seasonData.hotspotY : null;
        const orientation = seasonData.orientation ? seasonData.orientation : null;
        setPlanMasseOverlayPosition({ hotspotX, hotspotY, orientation });

        // Informations générales sur la saison
        const sunrise = seasonData.sunrise;
        const sunset = seasonData.sunset;
        const date = seasonData.date;
        setSunRise(sunrise);
        setSunSet(sunset);
        setDate(date);
      }
    }
  }, [selectedView, selectedDate, imageNumber, helioDatas, startTotalMinutes, timeStep]);

  // ------ Gestion du slider ------ //
  const handleSliderChange = (event) => {
    setImageNumber(parseInt(event.target.value), 10);
  };

  const handleImageMouseDown = (event) => {
    setDragging(true);
    setDragStartX(event.clientX);
    setDragStartImageNumber(imageNumber);
    setHasInteracted(true);
    setShowInstruction(false);
  };

  const handleImageMouseMove = (event) => {
    if (dragging) {
      const dragDistance = event.clientX - dragStartX;
      const dragThreshold = -10;
      const imageChange = Math.round(dragDistance / dragThreshold);
      let newImageNumber = dragStartImageNumber - imageChange;

      if (newImageNumber < 0) {
        newImageNumber = 0;
      } else if (newImageNumber > lastFrameNumber) {
        newImageNumber = lastFrameNumber;
      }
      setImageNumber(newImageNumber);
    }
  };

  const handleImageMouseUp = () => {
    setDragging(false);
  };

  const handleImageClick = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleImageMouseMove);
    window.addEventListener('mouseup', handleImageMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleImageMouseMove);
      window.removeEventListener('mouseup', handleImageMouseUp);
    };
  }, [dragging]);

  useEffect(() => {
    if (hasInteracted) {
      setShowInstruction(false);
    }
  }, [hasInteracted]);

  /* GESTION POUR MOBILES */

  const handleImageTouchStart = (event) => {
    setDragging(true);
    setDragStartX(event.touches[0].clientX);
    setDragStartImageNumber(imageNumber);
    setHasInteracted(true);
    setShowInstruction(false);
  };

  const handleImageTouchMove = (event) => {
    if (dragging) {
      const dragDistance = event.touches[0].clientX - dragStartX;
      const dragThreshold = -10;
      const imageChange = Math.round(dragDistance / dragThreshold);
      let newImageNumber = dragStartImageNumber - imageChange;

      if (newImageNumber < 0) {
        newImageNumber = 0;
      } else if (newImageNumber > lastFrameNumber) {
        newImageNumber = lastFrameNumber;
      }
      setImageNumber(newImageNumber);
    }
  };

  const handleImageTouchEnd = () => {
    setDragging(false);
  };

  useEffect(() => {
    window.addEventListener('touchmove', handleImageTouchMove);
    window.addEventListener('touchend', handleImageTouchEnd);

    return () => {
      window.removeEventListener('touchmove', handleImageTouchMove);
      window.removeEventListener('touchend', handleImageTouchEnd);
    };
  }, [dragging]);

  /* FIN GESTION POUR MOBILES */
  // ------ Fin gestion du slider ------ //

  return (
    <>
      <div ref={pdfRef}>
        {!selectedImagePath && helioDatas && helioDatas.generals && helioDatas.generals[0] && (
          <>
            <div className='projectContainer'
              onClick={handleBoxClick}
              onContextMenu={handleContextMenu}
              style={{ backgroundImage: `url(${helioDatas.generals[0].mainbackground})` }}
            >
              <div className='projectTitleMain'>
                {helioDatas.generals[0].project}

              </div>
            </div>
          </>
        )}
        <div>
          {selectedImagePath && (
            <div>
              {/* Informations générales */}
              <div className='projectTitle'>
                {helioDatas.generals[0].project}
              </div>
              {/*  */}
              {/* Changement images quand grab */}
              <div
                onMouseDown={handleImageMouseDown}
                onMouseUp={handleImageMouseUp}
                onClick={handleImageClick}
                onTouchStart={handleImageTouchStart}
                onTouchEnd={handleImageTouchEnd}
                onTouchMove={handleImageTouchMove}
                onContextMenu={handleContextMenu}
                style={{ cursor: dragging ? 'grabbing' : 'grab' }}
              >

                <img
                  className='imgGen'
                  src={selectedImagePath.replace(/\d{4}\./, `${imageNumber.toString().padStart(4, '0')}.`)}
                  alt="Fond de page"
                  draggable="false"
                />
              </div>
              {/*  */}

              {/* Gestion du plan masse */}
              {selectedView !== 'HELIO_CAM_TOP' && planMasseImagePath && (
                <div className="planMasseContainer"
                  onMouseDown={handleImageMouseDown}
                  onMouseUp={handleImageMouseUp}
                  onClick={handleImageClick}
                  onContextMenu={handleContextMenu}
                  style={{
                    cursor: dragging ? 'grabbing' : 'grab',
                  }}>
                  <img
                    src={planMasseImagePath.replace(/\d{4}\./, `${imageNumber.toString().padStart(4, '0')}.`)}
                    alt="Plan Masse"
                    className="planMasseImage"
                    draggable="false"
                  />
                  <div className="planMasseNord">N</div>
                  {window.innerWidth > 992 ? (
                    hotspotX && hotspotY && orientation && (
                      <Eye className="planMasseOverlay"
                        style={{
                          width: '50px',
                          height: '50px',
                          left: `${hotspotX}%`,
                          bottom: `${hotspotY}%`,
                          transform: `translate(-50%, 50%) rotate(${orientation}deg)`,
                        }} />
                    )) : (
                    hotspotX && hotspotY && orientation && (
                      <Eye className="planMasseOverlay"
                        style={{
                          width: '20px',
                          height: '20px',
                          left: `${hotspotX}%`,
                          bottom: `${hotspotY}%`,
                          transform: `translate(-50%, 50%) rotate(${orientation}deg)`,
                        }} />
                    ))
                  }
                </div>
              )}
            </div>
          )}
        </div>

        {!isNormalImage && (
          <div className='containerLegendsHeatMap'>
            <div className='textHeatMap'>
              <div className='textHeatMapTitle'>100 000</div>
              <div className='textHeatMapTitle'>75 000</div>
              <div className='textHeatMapTitle'>50 000</div>
              <div className='textHeatMapTitle'>25 000</div>
              <div className='textHeatMapTitle'>0</div>
            </div>
            <div className='legendHeatMap'>
              <div className='verticalLineHeatMap'></div>
            </div>
            <div className='unitHeatMap'>
              <div className='unitHeatMapText'>Lux</div>
            </div>
          </div>
        )}

        {/* Gestion du système de vues, de dates, de lightanalysis, de slider et des crédits */}
        <div className="buttonContainer">
          <div className='buttonContainerChoice'>
            <div className="buttonContainerMainChoice">
              <ViewSelector
                showViewButtons={showViewButtons}
                displayViewName={displayViewName}
                helioDatas={helioDatas}
                handleButtonClick={handleButtonClick}
                handleSelect={handleSelect}
                selectedView={selectedView}
              />
              {selectedView &&
                <DateSelector
                  selectedView={selectedView}
                  showDateButtons={showDateButtons}
                  displayDateName={displayDateName}
                  filteredViewData={filteredViewData}
                  handleButtonClick={handleButtonClick}
                  handleSelect={handleSelect}
                  selectedDate={selectedDate}
                />
              }
            </div>

            {selectedImagePath && lightAnalysis && (
              <LightSelector
                selectedView={selectedView}
                selectedDate={selectedDate}
                selectedImagePath={selectedImagePath}
                handleImageChange={handleImageChange}
                isNormalImage={isNormalImage}
              />
            )}

          </div>

          {selectedImagePath && (
            <Slider
              imageNumber={imageNumber}
              handleSliderChange={handleSliderChange}
              lastFrameNumber={lastFrameNumber}
              selectedDate={selectedDate}
              selectedView={selectedView}
              startTotalMinutes={startTotalMinutes}
              timeStep={timeStep}
              currentHour={currentHour}
              sunrise={sunrise}
              altitude={helioDatas.generals[0].altitude}
              sunset={sunset}
              date={date}
              totalMinutes={startTotalMinutes + imageNumber * timeStep}
              hourString={`${Math.floor((startTotalMinutes + imageNumber * timeStep) / 60).toString().padStart(2, '0')}:${((startTotalMinutes + imageNumber * timeStep) % 60).toString().padStart(2, '0')}`}
              previousFirstFrameNumber={previousFirstFrameNumber}
              previousImageNumber={previousImageNumber}
            />
          )}

          {helioDatas && helioDatas.generals && helioDatas.generals[0] && helioDatas.generals[0].logo && (
            <div className='logoContainer'>
              <Credits />
            </div>
          )}
        </div>
        {/* Fin gestion du système */}
      </div>

      {showInstruction && selectedImagePath && (
        <div
          className={`instruction ${showInstruction ? 'fade-in' : 'fade-out'}`}>
          <p>Cliquez et glissez</p>
        </div>
      )}
      <div className="optionsContainer">
        <FullScreen />
        {selectedImagePath && window.innerWidth > 992 &&
          <div className="downloadPNGContainer">
            <button
              className="downloadPNG"
              onClick={downloadImage}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                fill="black"
                width="30px"
                height="30px"
              >
                <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
              </svg>
            </button>
            <span className="toolTipTextOptions">Télécharger</span>
          </div>
        }
      </div>
    </>
  );
};

export default Home;